import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./PromptInput.module.scss";
/**
 * Textarea hosted inside a rounded card with a footer slot for a hint on the
 * left (e.g. `⌘ ⏎ — отправить`) and an action on the right. Cmd/Ctrl+Enter
 * triggers `onSubmit` with the current value.
 *
 * Layout-only — the consumer renders its own submit button and binds it to
 * onSubmit. Component is uncontrolled by default but accepts a controlled
 * `value` prop.
 */
export const PromptInput = ({ value, defaultValue, onChange, onSubmit, placeholder, hint, action, maxLength, rows = 2, autoFocus, className, id, name, }) => {
    const [internal, setInternal] = React.useState(defaultValue ?? "");
    const isControlled = value !== undefined;
    const current = isControlled ? value : internal;
    const handleChange = (e) => {
        const next = e.target.value;
        if (!isControlled)
            setInternal(next);
        onChange?.(next);
    };
    const handleKey = (e) => {
        if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            onSubmit?.(current);
        }
    };
    return (_jsxs("div", { className: cn(styles.field, className), children: [_jsx("textarea", { id: id, name: name, className: styles.textarea, value: current, onChange: handleChange, onKeyDown: handleKey, placeholder: placeholder, rows: rows, maxLength: maxLength, autoFocus: autoFocus }), _jsxs("div", { className: styles.footer, children: [hint && _jsx("div", { className: styles.hint, children: hint }), _jsxs("div", { className: styles.actions, children: [maxLength != null && (_jsxs("span", { className: styles.counter, children: [current.length, " / ", maxLength] })), action] })] })] }));
};
